import { MAX_SPREADSHEET_SHEET_NAME_LENGTH } from "../models/_consts";
import { autoFitColumns } from "./autoFitColumns";
import * as XLSX from "xlsx";

export type ErrorRow = Record<string, string | number>;

// One sheet, one row per problem. For the upload screens: a long list of
// failures is unusable on screen, while a spreadsheet can be filtered and the
// names copied out to check them.
export const downloadErrorsExcel = (
  rows: ErrorRow[],
  fileName: string,
  sheetName: string = "Errors"
): void => {
  if (rows.length === 0) return;

  const worksheet = XLSX.utils.json_to_sheet(rows);
  autoFitColumns(worksheet, rows);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    sheetName.slice(0, MAX_SPREADSHEET_SHEET_NAME_LENGTH)
  );

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
